// extracted by mini-css-extract-plugin
export default {"priorityWrapper":"WisePriorityComponent_priorityWrapper__ggo8U","icon":"WisePriorityComponent_icon__4nkKU"};